import React, { Fragment } from "react";

import { useAuth0 } from "@auth0/auth0-react";

import { CustomersReportsContent, NavBar } from "../components";

const CustomersReports = () => {
  const { user } = useAuth0();
  const { name, picture, email } = user;

  return (
    <Fragment>
      <NavBar />
      <div className="container flex-grow-1">
        <h1>{name} Reports</h1>
        <CustomersReportsContent />
      </div>
    </Fragment>
  );
};

export default CustomersReports;
